import { RootState } from '../../../../../../init-store';
import { isSipRoomAgent } from '../../../config/selectors';
import { MODAL_TYPES } from '../modal-type/constants';
import { selectModalType } from '../modal-type/selectors';

export const selectIsCommandListOpen = (state: RootState) => {
    return isSipRoomAgent(state) && selectModalType(state) === MODAL_TYPES.commandList;
};
